export var Status;
(function (Status) {
    Status["ACTIVE"] = "ACTIVE";
    Status["DEPRECATED"] = "DEPRECATED";
    Status["ARCHIVED"] = "ARCHIVED";
})(Status || (Status = {}));
export var AppType;
(function (AppType) {
    /** A Regular app entity - used to installed on sites */
    AppType["SITE_APP"] = "SITE_APP";
    /** represents an account API KEY to access wix services */
    AppType["API_KEY"] = "API_KEY";
    /** represents an app developed for Velo editor */
    AppType["VELO_APP"] = "VELO_APP";
    /** Private App that should be available only for the owner account / sub-accounts. */
    AppType["PRIVATE_APP"] = "PRIVATE_APP";
    /** represents an External Headless (3rd party) App that has access to Wix Public Services */
    AppType["HEADLESS"] = "HEADLESS";
})(AppType || (AppType = {}));
export var NamespaceType;
(function (NamespaceType) {
    NamespaceType["ACCOUNT"] = "ACCOUNT";
    NamespaceType["COMPANY"] = "COMPANY";
})(NamespaceType || (NamespaceType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Action;
(function (Action) {
    Action["CREATED"] = "CREATED";
    Action["UPDATED"] = "UPDATED";
    Action["DEPRECATED"] = "DEPRECATED";
    Action["DELETED"] = "DELETED";
})(Action || (Action = {}));
//# sourceMappingURL=types.impl.js.map